import { useLayoutEffect, useState } from "react";
import type { RefObject } from "react";

/**
 * @description Measures the rendered width of an SVG text element, re-measuring when `content` changes.
 * Returns 0 where layout is unavailable (e.g. jsdom has no getBBox).
 */
function useSvgTextWidth(ref: RefObject<SVGTextElement | null>, content: React.ReactNode) {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    setWidth(ref.current?.getBBox?.().width ?? 0);
  }, [content, ref]);

  return width;
}

export default useSvgTextWidth;
